import { HasPermissions } from './hasPermissions.types';
import { hasPermissions } from './hasPermissions';
import { useProfileQuery } from 'src/api/queries';

const usePermissions = (): HasPermissions => {
  const { data } = useProfileQuery({ enabled: false });
  const permissions = data?.permissions ?? [];

  return hasPermissions(permissions);
};

export { usePermissions };
